import { List } from '../objects/list';
import { User } from '../objects/user';
import { Errors } from '../objects/errors';
import { Role } from '../../role/objects/role';
import { UserStats } from '../objects/userStats';
import { PostResponse } from '../objects/postResponse';
import { Picture } from '../../picture/objects/picture';
import { Preferences } from '../../profile/objects/preferences';
import { Errors as PictureErrors } from '../../picture/objects/errors';
import { Organisation } from '../../organisation/objects/organisation';
import { OrganisationMinimal } from '../../organisation/objects/organisationMinimal';
import { RoleMinimal } from '../../role/objects/roleMinimal';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Column } from '../objects/column';

export const ADD_PREFERENCES = 'USER_ADD_PREFERENCES';
export const MOVE_DOWN_COLUMN = 'USER_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'USER_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'USER_RESET_FILTERS';
export const RESET_USER = 'USER_RESET_USER';
export const RESET_PROFIL_PICTURE = 'USER_RESET_PROFIL_PICTURE';
export const SET_ACTIVATE_USER = 'USER_SET_ACTIVATE_USER';
export const SET_DELETE_USER = 'USER_SET_DELETE_USER';
export const SET_DELETE_USERS = 'USER_SET_DELETE_USERS';
export const SET_ERRORS = 'USER_SET_ERRORS';
export const SET_EXPORT_TYPE = 'USER_SET_EXPORT_TYPE';
export const SET_LIMIT = 'USER_SET_LIMIT';
export const SET_LIST = 'USER_SET_LIST';
export const SET_MOVE_ORGANISATION_ORGANISATION = 'USER_SET_MOVE_ORGANISATION_ORGANISATION';
export const SET_MOVE_ORGANISATION_USER = 'USER_SET_MOVE_ORGANISATION_USER';
export const SET_ORDER_BY = 'USER_SET_ORDER_BY';
export const SET_PAGE = 'USER_SET_PAGE';
export const SET_PASSWORD_ID = 'USER_SET_PASSWORD_ID';
export const SET_PICTURE_ERRORS = 'USER_SET_PICTURE_ERRORS';
export const SET_POST_FINISHED = 'USER_SET_POST_FINISHED';
export const SET_POST_RESPONSE = 'USER_SET_POST_RESPONSE';
export const SET_PREFERENCES = 'USER_SET_PREFERENCES';
export const SET_RUNNING = 'USER_SET_RUNNING';
export const SET_SEARCH = 'USER_SET_SEARCH';
export const SET_SUSPEND_USER = 'USER_SET_SUSPEND_USER';
export const SET_SUSPEND_USERS = 'USER_SET_SUSPEND_USERS';
export const SET_UPLOAD_PICTURE_VIDEO_INPUT = 'USER_SET_UPLOAD_PICTURE_VIDEO_INPUT';
export const SET_USER = 'USER_SET_USER';
export const SET_USER_STATS = 'USER_SET_USER_STATS';
export const TOGGLE_NETWORK_DIRECTOR = 'USER_TOGGLE_NETWORK_DIRECTOR';
export const TOGGLE_AGENCY_DIRECTOR = 'USER_TOGGLE_AGENCY_DIRECTOR';
export const TOGGLE_BO_AGENT = 'USER_TOGGLE_BO_AGENT';
export const TOGGLE_CC_CREATOR = 'USER_TOGGLE_CC_CREATOR';
export const TOGGLE_COLUMN = 'USER_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'USER_TOGGLE_NEW';
export const TOGGLE_CUSTOM_PERMISSIONS = 'USER_TOGGLE_CUSTOM_PERMISSIONS';
export const TOGGLE_EMAIL_PREVIEW = 'USER_TOGGLE_EMAIL_PREVIEW';
export const TOGGLE_EXPORT = 'USER_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'USER_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'USER_TOGGLE_FILTERS';
export const TOGGLE_FIRST_BLOCK = 'USER_TOGGLE_FIRST_BLOCK';
export const TOGGLE_IS_CUSTOMER = 'USER_TOGGLE_IS_CUSTOMER';
export const TOGGLE_LIST_ALL = 'USER_TOGGLE_LIST_ALL';
export const TOGGLE_MOVE_ORGANISATION_CHANGE_TRIP = 'USER_TOGGLE_MOVE_ORGANISATION_CHANGE_TRIP';
export const TOGGLE_PROFILE_DEPLOYED = 'USER_TOGGLE_PROFILE_DEPLOYED';
export const TOGGLE_REFRESH = 'USER_TOGGLE_REFRESH';
export const TOGGLE_ROLE_DEPLOYED = 'USER_TOGGLE_ROLE_DEPLOYED';
export const TOGGLE_SELLER_AGENT = 'USER_TOGGLE_SELLER_AGENT';
export const TOGGLE_IS_COMMERCIAL = 'USER_TOGGLE_IS_COMMERCIAL';
export const TOGGLE_SUPPORT_ACCESS = 'TOGGLE_SUPPORT_ACCESS';
export const TOGGLE_SUSPEND_TRANSFER = 'USER_TOGGLE_SUSPEND_TRANSFER';
export const TOGGLE_UPDATE_PASSWORD = 'USER_TOGGLE_UPDATE_PASSWORD';
export const TOGGLE_UPLOAD_PICTURE = 'USER_TOGGLE_UPLOAD_PICTURE';
export const TOGGLE_USER_TRANSFER = 'USER_TOGGLE_USER_TRANSFER';
export const TOGGLE_USER_TRANSFER_ERROR = 'USER_TOGGLE_USER_TRANSFER_ERROR';
export const UPDATE_BIOGRAPHY = 'USER_UPDATE_BIOGRAPHY';
export const UPDATE_CELLPHONE_NUMBER = 'USER_UPDATE_CELLPHONE_NUMBER';
export const UPDATE_CITY = 'USER_UPDATE_CITY';
export const UPDATE_CLIENT = 'USER_UPDATE_CLIENT';
export const UPDATE_CLIENTS = 'USER_UPDATE_CLIENTS';
export const UPDATE_COUNTRY = 'USER_UPDATE_COUNTRY';
export const UPDATE_COMPANY = 'USER_UPDATE_COMPANY';
export const UPDATE_EMAIL = 'USER_UPDATE_EMAIL';
export const UPDATE_FILTER_COMPANY = 'USER_UPDATE_FILTER_COMPANY';
export const UPDATE_FILTER_CREATOR = 'USER_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_DATE_JOINED_GTE = 'USER_UPDATE_FILTER_DATE_JOINED_GTE';
export const UPDATE_FILTER_DATE_JOINED_LTE = 'USER_UPDATE_FILTER_DATE_JOINED_LTE';
export const UPDATE_FILTER_EMAIL = 'USER_UPDATE_FILTER_EMAIL';
export const UPDATE_FILTER_EMAIL_CHECKED = 'USER_UPDATE_FILTER_EMAIL_CHECKED';
export const UPDATE_FILTER_FIRST_NAME = 'USER_UPDATE_FILTER_FIRST_NAME';
export const UPDATE_FILTER_LAST_AUTHOR = 'USER_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_LAST_NAME = 'USER_UPDATE_FILTER_LAST_NAME';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'USER_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'USER_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'USER_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'USER_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FILTER_SHOW_DEACTIVATED = 'USER_UPDATE_FILTER_SHOW_DEACTIVATED';
export const UPDATE_FILTER_USER_TYPE = 'USER_UPDATE_FILTER_USER_TYPE';
export const UPDATE_FIRST_NAME = 'USER_UPDATE_FIRST_NAME';
export const UPDATE_GENERATE_PASSWORD = 'USER_UPDATE_GENERATE_PASSWORD';
export const UPDATE_IGA_PASSWORD = 'USER_UPDATE_IGA_PASSWORD';
export const UPDATE_IGA_USERNAME = 'USER_UPDATE_IGA_USERNAME';
export const UPDATE_LANG = 'USER_UPDATE_LANG';
export const UPDATE_BRANCH_CODE = 'USER_UPDATE_BRANCH_CODE';
export const UPDATE_LAST_NAME = 'USER_UPDATE_LAST_NAME';
export const UPDATE_LIST_ORGANISATIONS = 'USER_UPDATE_LIST_ORGANISATIONS';
export const UPDATE_MOVE_SECONDARY_ORGANISATIONS = 'USER_UPDATE_MOVE_SECONDARY_ORGANISATIONS';
export const UPDATE_PASSWORD = 'USER_UPDATE_PASSWORD';
export const UPDATE_PHONE_NUMBER = 'USER_UPDATE_PHONE_NUMBER';
export const UPDATE_PICTURE = 'USER_UPDATE_PICTURE';
export const UPDATE_PICTURE_PROGRESS = 'USER_UPDATE_PICTURE_PROGRESS';
export const UPDATE_PICTURE_STEP = 'USER_UPDATE_PICTURE_STEP';
export const UPDATE_ROLE = 'USER_UPDATE_ROLE';
export const UPDATE_STATE = 'USER_UPDATE_STATE';
export const UPDATE_STREET = 'USER_UPDATE_STREET';
export const UPDATE_TRIGRAM = 'USER_UPDATE_TRIGRAM';
export const UPDATE_USERNAME = 'USER_UPDATE_USERNAME';
export const UPDATE_USER_SELECTED = 'USER_UPDATE_USER_SELECTED';
export const UPDATE_USER_TRANSFER = 'USER_UPDATE_USER_TRANSFER';
export const UPDATE_USER_TRIP_TRANSFER = 'USER_UPDATE_USER_TRIP_TRANSFER';
export const UPDATE_ZIP_CODE = 'USER_UPDATE_ZIP_CODE';
export const SET_COLUMNS = 'USER_SET_COLUMNS';
export const SET_USER_SUGGESTIONS = 'USER_SET_USER_SUGGESTIONS';
export const SET_USER_SUGGESTION_SELECTED = 'USER_SET_USER_SUGGESTION_SELECTED';
export const UNSELECT_USER_CRM = 'USER_UNSELECT_USER_CRM';



interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}
interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface ResetUserAction {
    type: typeof RESET_USER
}

interface ResetProfilPicture {
    type: typeof RESET_PROFIL_PICTURE
}

interface SetActivateUserAction {
    type: typeof SET_ACTIVATE_USER,
    payload: null | false | User
}

interface SetDeleteUserAction {
    type: typeof SET_DELETE_USER,
    payload: null | false | User
}

interface SetDeleteUsersAction {
    type: typeof SET_DELETE_USERS
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Errors
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetMoveOrganisationOrganisationAction {
    type: typeof SET_MOVE_ORGANISATION_ORGANISATION,
    payload: null | Organisation
}

interface SetMoveOrganisationUserAction {
    type: typeof SET_MOVE_ORGANISATION_USER,
    payload: null | User
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPasswordIdAction {
    type: typeof SET_PASSWORD_ID,
    payload: {
        client: null | number,
        id: null | number,
        name: string
    }
}

interface SetPictureErrorsAction {
    type: typeof SET_PICTURE_ERRORS,
    payload: PictureErrors | null
}

interface SetPostFinishedAction {
    type: typeof SET_POST_FINISHED,
    payload: boolean
}

interface SetPostResponseAction {
    type: typeof SET_POST_RESPONSE,
    payload: null | PostResponse
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface SetSuspendUserAction {
    type: typeof SET_SUSPEND_USER,
    payload: null | false | User
}

interface SetSuspendUsersAction {
    type: typeof SET_SUSPEND_USERS
}

interface SetUploadPictureVideoInputAction {
    type: typeof SET_UPLOAD_PICTURE_VIDEO_INPUT,
    payload: boolean
}

interface SetUserAction {
    type: typeof SET_USER,
    payload: User
}

interface SetUserStatsAction {
    type: typeof SET_USER_STATS,
    payload: UserStats
}

interface ToggleNetworkDirectorAction {
    type: typeof TOGGLE_NETWORK_DIRECTOR
}
interface ToggleAgencyDirectorAction {
    type: typeof TOGGLE_AGENCY_DIRECTOR
}
interface ToggleBoAgentAction {
    type: typeof TOGGLE_BO_AGENT
}

interface ToggleCcCreatorAction {
    type: typeof TOGGLE_CC_CREATOR
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleCreateAction {
    type: typeof TOGGLE_CREATE,
    payload: number
}

interface ToggleCustomPermissionsAction {
    type: typeof TOGGLE_CUSTOM_PERMISSIONS,
    payload: boolean
}

interface ToggleEmailPreviewAction {
    type: typeof TOGGLE_EMAIL_PREVIEW
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleFirstBlockAction {
    type: typeof TOGGLE_FIRST_BLOCK
}

interface ToggleIsCustomerAction {
    type: typeof TOGGLE_IS_CUSTOMER
}

interface ToggleListAllAction {
    type: typeof TOGGLE_LIST_ALL,
    payload: boolean
}

interface toggleMoveOrganisationChangeTripAction {
    type: typeof TOGGLE_MOVE_ORGANISATION_CHANGE_TRIP
}

interface ToggleProfileDeployedAction {
    type: typeof TOGGLE_PROFILE_DEPLOYED,
    payload: boolean
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface ToggleRoleDeployedAction {
    type: typeof TOGGLE_ROLE_DEPLOYED,
    payload: boolean
}

interface ToggleSellerAgentAction {
    type: typeof TOGGLE_SELLER_AGENT
}

interface ToggleIsCommercialAction {
    type: typeof TOGGLE_IS_COMMERCIAL
}

interface ToggleSupportAccessAction {
    type: typeof TOGGLE_SUPPORT_ACCESS
}

interface ToggleSuspendTransferAction {
    type: typeof TOGGLE_SUSPEND_TRANSFER
}

interface ToggleUpdatePasswordAction {
    type: typeof TOGGLE_UPDATE_PASSWORD,
    payload: boolean
}

interface ToggleUploadPictureAction {
    type: typeof TOGGLE_UPLOAD_PICTURE
}

interface ToggleUserTransferAction {
    type: typeof TOGGLE_USER_TRANSFER
}

interface ToggleUserTransferErrorAction {
    type: typeof TOGGLE_USER_TRANSFER_ERROR
}

interface UpdateBiographyAction {
    type: typeof UPDATE_BIOGRAPHY,
    payload: string
}

interface UpdateCellphoneNumberAction {
    type: typeof UPDATE_CELLPHONE_NUMBER,
    payload: string
}

interface UpdateCityAction {
    type: typeof UPDATE_CITY,
    payload: string
}

interface UpdateClientAction {
    type: typeof UPDATE_CLIENT,
    payload: Organisation | OrganisationMinimal | null
}

interface UpdateClientsAction {
    type: typeof UPDATE_CLIENTS,
    payload: Organisation[]
}

interface UpdateCountryAction {
    type: typeof UPDATE_COUNTRY,
    payload: null| IataCountry
}

interface UpdateEmailAction {
    type: typeof UPDATE_EMAIL,
    payload: string
}

interface UpdateCompanyAction {
    type: typeof UPDATE_COMPANY,
    payload: string
}

interface UpdateFilterCompanyAction {
    type: typeof UPDATE_FILTER_COMPANY,
    payload: string
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterDateJoinedGteAction {
    type: typeof UPDATE_FILTER_DATE_JOINED_GTE,
    payload: Date | null
}

interface UpdateFilterDateJoinedLteAction {
    type: typeof UPDATE_FILTER_DATE_JOINED_LTE,
    payload: Date | null
}

interface UpdateFilterEmailAction {
    type: typeof UPDATE_FILTER_EMAIL,
    payload: string
}

interface UpdateFilterEmailCheckedAction {
    type: typeof UPDATE_FILTER_EMAIL_CHECKED,
    payload: '' | boolean
}

interface UpdateFilterFirstNameAction {
    type: typeof UPDATE_FILTER_FIRST_NAME,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterLastNameAction {
    type: typeof UPDATE_FILTER_LAST_NAME,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFilterShowDeactivatedAction {
    type: typeof UPDATE_FILTER_SHOW_DEACTIVATED,
    payload: 'BOTH' | 'SHOW' | 'HIDE'
}

interface UpdateFilterUserTypeAction {
    type: typeof UPDATE_FILTER_USER_TYPE,
    payload: 'ALL' | 'AGENT' | 'CUSTOMER'
}

interface UpdateFirstNameAction {
    type: typeof UPDATE_FIRST_NAME,
    payload: string
}

interface UpdateGeneratePasswordAction {
    type: typeof UPDATE_GENERATE_PASSWORD,
    payload: boolean
}

interface UpdateIgaPasswordAction {
    type: typeof UPDATE_IGA_PASSWORD,
    payload: string
}

interface UpdateIgaUsernameAction {
    type: typeof UPDATE_IGA_USERNAME,
    payload: string
}

interface UpdateLangAction {
    type: typeof UPDATE_LANG,
    payload: string
}

interface UpdateBranchCodeAction {
    type: typeof UPDATE_BRANCH_CODE,
    payload: "fr" | "be"
}

interface UpdateLastNameAction {
    type: typeof UPDATE_LAST_NAME,
    payload: string
}

interface UpdateListOrganisationsAction {
    type: typeof UPDATE_LIST_ORGANISATIONS,
    payload: Organisation[]
}

interface UpdateMoveSecondaryOrganisationsAction {
    type: typeof UPDATE_MOVE_SECONDARY_ORGANISATIONS,
    payload: Organisation[] | OrganisationMinimal[]
}

interface UpdatePasswordAction {
    type: typeof UPDATE_PASSWORD,
    payload: string
}

interface UpdatePhoneNumberAction {
    type: typeof UPDATE_PHONE_NUMBER,
    payload: string
}

interface UpdatePictureAction {
    type: typeof UPDATE_PICTURE,
    payload: Picture | null
}

interface UpdatePictureProgressAction {
    type: typeof UPDATE_PICTURE_PROGRESS,
    payload: number
}

interface UpdatePictureStepAction {
    type: typeof UPDATE_PICTURE_STEP,
    payload: 1 | 2
}

interface UpdateRoleAction {
    type: typeof UPDATE_ROLE,
    payload: (Role |RoleMinimal)[]
}

interface UpdateStateAction {
    type: typeof UPDATE_STATE,
    payload: string
}

interface UpdateStreetAction {
    type: typeof UPDATE_STREET,
    payload: string
}

interface UpdateTrigramAction {
    type: typeof UPDATE_TRIGRAM,
    payload: string
}

interface UpdateUsernameAction {
    type: typeof UPDATE_USERNAME,
    payload: string
}

interface UpdateUserSelectedAction {
    type: typeof UPDATE_USER_SELECTED,
    payload: string | User
}

interface UpdateUserTransferAction {
    type: typeof UPDATE_USER_TRANSFER,
    payload: null | User
}

interface UpdateUserTripTransferAction {
    type: typeof UPDATE_USER_TRIP_TRANSFER,
    payload: null | User
}

interface UpdateZipCodeAction {
    type: typeof UPDATE_ZIP_CODE,
    payload: string
}

interface SetUserSuggestionsAction {
    type: typeof SET_USER_SUGGESTIONS,
    payload: User[]
}

interface SetUserSuggestionSelectedAction {
    type: typeof SET_USER_SUGGESTION_SELECTED,
    payload: User | null
}
interface UnselectUserCrmAction {
    type: typeof UNSELECT_USER_CRM,
}

export type UserActionTypes =
    SetColumnsAction |
    AddPreferencesAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    ResetUserAction |
    ResetProfilPicture |
    SetActivateUserAction |
    SetDeleteUserAction |
    SetDeleteUsersAction |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetMoveOrganisationOrganisationAction |
    SetMoveOrganisationUserAction |
    SetOrderByAction |
    SetPageAction |
    SetPasswordIdAction |
    SetPictureErrorsAction |
    SetPostFinishedAction |
    SetPostResponseAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    SetSuspendUserAction |
    SetSuspendUsersAction |
    SetUploadPictureVideoInputAction |
    SetUserAction |
    SetUserStatsAction |
    ToggleAgencyDirectorAction |
    ToggleNetworkDirectorAction |
    ToggleBoAgentAction |
    ToggleCcCreatorAction |
    ToggleColumnAction |
    ToggleCreateAction |
    ToggleCustomPermissionsAction |
    ToggleEmailPreviewAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleFirstBlockAction |
    ToggleIsCustomerAction |
    ToggleListAllAction |
    toggleMoveOrganisationChangeTripAction |
    ToggleProfileDeployedAction |
    ToggleRefreshAction |
    ToggleRoleDeployedAction |
    ToggleSellerAgentAction |
    ToggleIsCommercialAction |
    ToggleSupportAccessAction |
    ToggleSuspendTransferAction |
    ToggleUpdatePasswordAction |
    ToggleUploadPictureAction |
    ToggleUserTransferAction |
    ToggleUserTransferErrorAction |
    UpdateBiographyAction |
    UpdateCellphoneNumberAction |
    UpdateCityAction |
    UpdateClientAction |
    UpdateClientsAction |
    UpdateCountryAction |
    UpdateCompanyAction |
    UpdateEmailAction |
    UpdateFilterCompanyAction |
    UpdateFilterCreatorAction |
    UpdateFilterDateJoinedGteAction |
    UpdateFilterDateJoinedLteAction |
    UpdateFilterEmailAction |
    UpdateFilterEmailCheckedAction |
    UpdateFilterFirstNameAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterLastNameAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFilterShowDeactivatedAction |
    UpdateFilterUserTypeAction |
    UpdateFirstNameAction |
    UpdateGeneratePasswordAction |
    UpdateIgaPasswordAction |
    UpdateIgaUsernameAction |
    UpdateLangAction |
    UpdateBranchCodeAction |
    UpdateLastNameAction |
    UpdateListOrganisationsAction |
    UpdateMoveSecondaryOrganisationsAction |
    UpdatePasswordAction |
    UpdatePhoneNumberAction |
    UpdatePictureAction |
    UpdatePictureProgressAction |
    UpdatePictureStepAction |
    UpdateRoleAction |
    UpdateStateAction |
    UpdateStreetAction |
    UpdateTrigramAction |
    UpdateUsernameAction |
    UpdateUserSelectedAction |
    UpdateUserTransferAction |
    UpdateUserTripTransferAction |
    UpdateZipCodeAction |
    SetUserSuggestionsAction |
    SetUserSuggestionSelectedAction |
    UnselectUserCrmAction;